import { toast } from 'react-toastify'
import { ToastWayniLogo } from 'assets/icons'
import { contentTypeClass } from './Toast'

export default function handleNotification() {
  const getMessage = (message, icon = <ToastWayniLogo />) => (
    <button
      className='w-full text-xl flex font-semibold text-left items-center justify-center my-5'
      type='button'
    >
      <span className='shrink-0'>{icon}</span>
      <span className='ml-4'>{message}</span>
    </button>
  )

  return {
    errorToast: (message, icon) =>
      toast(getMessage(message, icon), {
        type: contentTypeClass.ERROR
      }),
    successToast: (message, icon) =>
      toast(getMessage(message, icon), {
        type: contentTypeClass.SUCCESS
      }),
    infoToast: (message, icon) =>
      toast(getMessage(message, icon), {
        type: contentTypeClass.INFO
      })
  }
}
